<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      :loading="isLoadingMap.table === true"
      class="elevation-1"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td class="text-center">
            <avatar :firstname="item.objectKey" :size="35" :font="14" />
          </td>
          <td>
            {{ `${item.objectKey}`.trim() }} <br>
            <span class="caption grey--text">{{ item.role }}</span>
          </td>
          <td>
            {{ `${item.size}` }}
          </td>
          <td>rvt</td>
          <td>
            <v-chip
              small outlined rounded :color="modelStatus(item, 'color')" 
            >
              {{ modelStatus(item, "label") }}
            </v-chip>
          </td>
          <td class="text-center">
            <v-progress-circular
              v-if="isLoadingMap[item.id] === true"
              :size="20"
              :width="2"
              color="primary"
              indeterminate
            />
            <v-menu 
              v-if="isLoadingMap[item.id] !== true" :key="item.id" left 
            >
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="shownMenu = true">
                  <v-icon>{{ $t('generic.icon.more_vert') }}</v-icon>
                </v-btn>
              </template>

              <v-list v-show="shownMenu" dense>
                <v-list-item
                  v-if="item.joined !== true"
                  @click.stop="convertModel(item)"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon left small>
                        {{ $t('generic.icon.slideshow') }}
                      </v-icon>
                      {{ $t("generic.button.view_model") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <!-- Edit option -->
                <v-list-item @click.stop="onEdit(item)">
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon left small>
                        {{ $t("generic.icon.edit") }}
                      </v-icon>
                      {{ $t("generic.button.edit") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <!-- Delete option -->
                <generic-confirmation-modal
                  :id="item.id"
                  :title="$t('modal.central_model.delete.title')"
                  :action-name="$t('generic.action.delete')"
                  :message="$t('modal.central_model.delete.confirmation_msg')"
                  @close="onClose()"
                  @action="onDelete(item.objectKey)"
                >
                  <template v-slot:activator="{ on }">
                    <v-list-item v-on="on" @click.stop="">
                      <v-list-item-content>
                        <v-list-item-title class="error--text">
                          <v-icon left small color="error">
                            {{ $t("generic.icon.delete") }}
                          </v-icon>
                          {{ $t("generic.button.delete") }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </generic-confirmation-modal>
              </v-list>
            </v-menu>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Avatar from "@/components/Avatar";
// eslint-disable-next-line import/no-unresolved
import GenericConfirmationModal from "@/components/Modals/GenericConfirmationModal";

export default {
  components: { Avatar, GenericConfirmationModal },
  props: {
    projectId: { type: String, default: "" }
  },
  data() {
    return {
      shownMenu: true,
      isLoadingMap: {},
      list: [],
      headers: [
        {
          text: "",
        },
        {
          text: this.$t('generic.table_headers.name'),
        },
        {
          text: this.$t('generic.table_headers.size'),
        },
        {
          text: this.$t('generic.table_headers.type'),
        },
        {
           text: this.$t('generic.table_headers.status'),
        },
        {
          text: this.$t('generic.table_headers.actions'),
          align: "right",
        },
      ],
    };
  },
  async mounted() {
    await this.fetchProjectById(this.$route.params.id)
    await this.loadTable();
  },
  methods: {
    ...mapActions(["fetchProjectById", "fetchBucketList", "convertFileSVF", "deleteModel", "getCentralModelByFileName"]),
    onClose() {
      this.shownMenu = false
    },
    modelStatus(user, key) {
      const map = {
        JOINED: {
          color: "green",
          label: "Viewable",
        },
        INVITED: {
          color: "warning",
          label: "Corupted",
        },
        NOT_INVITED: {
          color: "green",
          label: "Viewable",
        },
      };

      if (user.joined === true) {
        return map.JOINED[key];
      }
      if (user.invited === true) {
        return map.INVITED[key];
      }

      return map.NOT_INVITED[key];
    },
    onEdit(item) {
      this.$router.push({
        name: "update-central-model",
        params: { model: item, action: 'EDIT' },
      });
    },
    async onDelete(itemtId) {
      this.setIsLoadingMap("table", true)
      const successMsg = this.$t('generic.message.success', [this.$t('entity.central_model'), this.$t('generic.action_performed.deleted')])
      const errorMsg = this.$t('generic.message.error', [this.$t('entity.central_model'), this.$t('generic.action_performed.deleted')])
      const centralModel = await this.getCentralModelByFileName({ fileName: itemtId, projectId: this.$route.params.id })

      await this.deleteModel( { collection: 'central-model', projectId: this.$route.params.id, id: centralModel.id })
        .then(() => {
          this.showSnackbar(successMsg, this.$t('generic.status.success'))
          this.loadTable();
        }).catch(() => {
          this.showSnackbar(errorMsg, this.$t('generic.status.error'));
        }).finally(() => { this.setIsLoadingMap("table", false) })
    },
    setIsLoadingMap(id, value) {
      this.isLoadingMap = {
        ...this.isLoadingMap,
        [id]: !!value,
      };
    },
    async convertModel(item) {
      const payload = { ...item };
      this.setIsLoadingMap("table", true);
      const convert = await this.convertFileSVF(payload)
        .then((res) => {
          console.log(res);
          this.$router.push({
            name: "model-viewer",
            params: {
              urn: res.data.convert.urn,
              // eslint-disable-next-line no-underscore-dangle
              token: res.data.token._fieldsProto.access_token.stringValue,
              id: this.$route.params.id,
            },
          });
        })
        .finally(() => {
          this.setIsLoadingMap("table", false);
        });

      this.convert = [...convert];
    },
    async loadTable() {
      const payload = {
        projectId: this.$route.params.id,
      };
      this.setIsLoadingMap("table", true);
      const list = await this.fetchBucketList(payload)
        .then((res) => res)
        .finally(() => {
          this.setIsLoadingMap("table", false);
        });

      // TODO How will be filtered this table when the central model it's archived????
      this.list = [...list];
    },
  },
};
</script>
